import { render, staticRenderFns } from "./HeroComponentSlide.vue?vue&type=template&id=6e0a1f66&scoped=true&"
import script from "./HeroComponentSlide.vue?vue&type=script&lang=js&"
export * from "./HeroComponentSlide.vue?vue&type=script&lang=js&"
import style0 from "./HeroComponentSlide.vue?vue&type=style&index=0&id=6e0a1f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a1f66",
  null
  
)

export default component.exports